import { HeightRangePair } from "../../system";
import { Color } from "../../drawing/Color";
import { GraphValueItem } from "./GraphValueItem";

export class GraphSubItem {
  name: string;
  rangeOfValue: HeightRangePair<number>;
  backColor: Color;
  foreColor: Color;
  graphValues: GraphValueItem[];

  clone(): GraphSubItem {
    const cloned = new GraphSubItem();
    cloned.name = this.name;
    cloned.rangeOfValue = this.rangeOfValue ? this.rangeOfValue.clone() : null;
    cloned.backColor = this.backColor ? this.backColor.clone() : null;
    cloned.foreColor = this.foreColor ? this.foreColor.clone() : null;
    if (this.graphValues) {
      const values: GraphValueItem[] = [];
      for (const graphValue of this.graphValues) {
        values.push(graphValue.clone());
      }
      cloned.graphValues = values;
    }
    return cloned;
  }
}
